// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputField_label__5A4A\\+ {
	position: relative;
	max-width: 482px;
	width: 100%;
	min-height: 60px;
	height: 60px;
	flex-shrink: 0;
	border-radius: 5px;
	border: 1px solid #f4f4f4;
	background: #f9f9f9;
	padding: 12px 23px 12px 28px;
	outline: none;
}

.InputField_label__5A4A\\+.InputField_ignoreHeight__Oirzy {
	height: initial !important;
}

.InputField_inputFieldCon__DXBoI {
	gap: 15px;
}

.InputField_input__RQj8i,
.InputField_label__5A4A\\+ input,
.InputField_label__5A4A\\+ .InputField_countryInput__gqHDW {
	width: 100%;
	color: #4e4e4e;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	/* line-height: 36px; * 225% * */
	border: none;
	outline: none;
	/* background-color: #f9f9f9 !important; */
	background-color: transparent !important;
}

.InputField_input__RQj8i[type='date'] {
	opacity: 0;
}

.InputField_input__RQj8i[type='date']:focus {
	opacity: 1;
}

.InputField_label__5A4A\\+ select[class='PhoneInputCountrySelect'] option {
	width: 100%;
	color: #4e4e4e;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	/* line-height: 36px; * 225% * */
	border: none;
	outline: none;
	/* background-color: #f9f9f9 !important; */
	background-color: transparent !important;
	height: 60px;
}

.InputField_filled__pchvw {
	opacity: 1 !important;
}

.InputField_placeholderSpan__ma\\+hb {
	color: rgba(78, 78, 78, 0.8) !important;
	line-height: 36px;
	position: absolute;
	top: 12px;
	left: 28px;
	width: initial !important;
}

.InputField_selectControl__NUc-I {
	padding: 12px 23px 12px 28px;
	box-shadow: none !important;
}

.InputField_selectControl__NUc-I:focus {
	box-shadow: none !important;
	border-color: transparent !important;
}

.InputField_selectOption__gqtlH {
	width: 200px;
}

.InputField_countryInput__gqHDW {
}

.InputField_input__RQj8i.InputField_password__g6C1Y {
	/* max-width: 352.339px; */
	flex: 1 1;
}

.InputField_mini__20hfs {
	width: 48% !important;
}

.InputField_label__5A4A\\+:focus-within {
	background-color: #fff !important;
}

.InputField_label__5A4A\\+:focus-within .InputField_input__RQj8i,
.InputField_label__5A4A\\+:focus-within input,
.InputField_label__5A4A\\+:focus-within .InputField_countryInput__gqHDW {
	background-color: #fff !important;
}

.InputField_setVisible__NzyOs {
	width: 24px;
	height: 24px;
}

.InputField_innerLabel__3CIPe {
	color: #666;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 18px; /* 150% */
	margin-bottom: 8px !important;
}

.InputField_input___E30dc {
	display: flex;
	padding: 16px;
	flex-direction: column;
	align-items: flex-start;
	gap: 10px;
	align-self: stretch;
	border-radius: 8px;
	border: 1px solid #ccc;
	background: #fff;
	color: #666 !important;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 150% */
}

.InputField_select__tzg6p {
	/* display: flex;
	gap: 10px; */
	align-self: stretch;
	border-radius: 8px;
	border: 1px solid #ccc !important;
	background: #fff !important;
	color: #666 !important;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 150% */
}

.InputField_selectControl___vCWw6 {
	padding: 16px;
	color: #666 !important;
	box-shadow: none !important;
}

.InputField_valueContainer__pre25 > div {
	color: #666 !important;
}

.InputField_requiredMark__q0OlL {
	color: #e41d1d;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 18px;
}

.InputField_indicatorsContainer__3w9VC > span {
	display: none;
}

.InputField_indicatorsContainer__3w9VC > div {
	padding: 0;
}

.InputField_pInnerLabel__gzK-M {
	color: #494747 !important;
	font-family: Manrope !important;
	font-size: 14px !important;
	font-style: normal !important;
	font-weight: 600 !important;
	line-height: 18px !important; /* 128.571% */
	text-transform: uppercase;
	margin-bottom: 8px;
}

.InputField_pLabel__2anQ3 {
	min-height: 56px;
	height: 56px;
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {
}

@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) {
	.InputField_input__RQj8i,
	.InputField_countryInput__gqHDW {
		gap: 11px;
	}
}

@media only screen and (max-width: 820px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {
}

@media only screen and (max-width: 480px) {
	.InputField_mini__20hfs {
		width: 100% !important;
	}
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
}

@media only screen and (max-width: 360px) {
}

@media only screen and (max-width: 360px) and (min-width: 301px) {
}

@media only screen and (max-width: 300px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/InputField.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;CAChB,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,4BAA4B;CAC5B,aAAa;AACd;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,SAAS;AACV;;AAEA;;;CAGC,WAAW;CACX,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,gCAAgC;CAChC,YAAY;CACZ,aAAa;CACb,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;CACX,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,gCAAgC;CAChC,YAAY;CACZ,aAAa;CACb,0CAA0C;CAC1C,wCAAwC;CACxC,YAAY;AACb;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,yBAAyB;AAC1B;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;CAC3B,oCAAoC;AACrC;;AAEA;CACC,YAAY;AACb;;AAEA;AACA;;AAEA;CACC,0BAA0B;CAC1B,SAAO;AACR;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;;;CAGC,iCAAiC;AAClC;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,SAAS;CACT,mBAAmB;CACnB,kBAAkB;CAClB,sBAAsB;CACtB,gBAAgB;CAChB,sBAAsB;CACtB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC;aACY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,iCAAiC;CACjC,2BAA2B;CAC3B,sBAAsB;CACtB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,+BAA+B;CAC/B,0BAA0B;CAC1B,6BAA6B;CAC7B,2BAA2B;CAC3B,4BAA4B,EAAE,aAAa;CAC3C,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA,yDAAyD;AACzD;AACA;;AAEA;AACA;;AAEA;CACC;;EAEC,SAAS;CACV;AACD;;AAEA;AACA;;AAEA;AACA;;AAEA;CACC;EACC,sBAAsB;CACvB;AACD;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".label {\n\tposition: relative;\n\tmax-width: 482px;\n\twidth: 100%;\n\tmin-height: 60px;\n\theight: 60px;\n\tflex-shrink: 0;\n\tborder-radius: 5px;\n\tborder: 1px solid #f4f4f4;\n\tbackground: #f9f9f9;\n\tpadding: 12px 23px 12px 28px;\n\toutline: none;\n}\n\n.label.ignoreHeight {\n\theight: initial !important;\n}\n\n.inputFieldCon {\n\tgap: 15px;\n}\n\n.input,\n.label input,\n.label .countryInput {\n\twidth: 100%;\n\tcolor: #4e4e4e;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 36px; * 225% * */\n\tborder: none;\n\toutline: none;\n\t/* background-color: #f9f9f9 !important; */\n\tbackground-color: transparent !important;\n}\n\n.input[type='date'] {\n\topacity: 0;\n}\n\n.input[type='date']:focus {\n\topacity: 1;\n}\n\n.label select[class='PhoneInputCountrySelect'] option {\n\twidth: 100%;\n\tcolor: #4e4e4e;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 36px; * 225% * */\n\tborder: none;\n\toutline: none;\n\t/* background-color: #f9f9f9 !important; */\n\tbackground-color: transparent !important;\n\theight: 60px;\n}\n\n.filled {\n\topacity: 1 !important;\n}\n\n.placeholderSpan {\n\tcolor: rgba(78, 78, 78, 0.8) !important;\n\tline-height: 36px;\n\tposition: absolute;\n\ttop: 12px;\n\tleft: 28px;\n\twidth: initial !important;\n}\n\n.selectControl {\n\tpadding: 12px 23px 12px 28px;\n\tbox-shadow: none !important;\n}\n\n.selectControl:focus {\n\tbox-shadow: none !important;\n\tborder-color: transparent !important;\n}\n\n.selectOption {\n\twidth: 200px;\n}\n\n.countryInput {\n}\n\n.input.password {\n\t/* max-width: 352.339px; */\n\tflex: 1;\n}\n\n.mini {\n\twidth: 48% !important;\n}\n\n.label:focus-within {\n\tbackground-color: #fff !important;\n}\n\n.label:focus-within .input,\n.label:focus-within input,\n.label:focus-within .countryInput {\n\tbackground-color: #fff !important;\n}\n\n.setVisible {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.innerLabel {\n\tcolor: #666;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 18px; /* 150% */\n\tmargin-bottom: 8px !important;\n}\n\n.input_ {\n\tdisplay: flex;\n\tpadding: 16px;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 10px;\n\talign-self: stretch;\n\tborder-radius: 8px;\n\tborder: 1px solid #ccc;\n\tbackground: #fff;\n\tcolor: #666 !important;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 24px; /* 150% */\n}\n\n.select {\n\t/* display: flex;\n\tgap: 10px; */\n\talign-self: stretch;\n\tborder-radius: 8px;\n\tborder: 1px solid #ccc !important;\n\tbackground: #fff !important;\n\tcolor: #666 !important;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 24px; /* 150% */\n}\n\n.selectControl_ {\n\tpadding: 16px;\n\tcolor: #666 !important;\n\tbox-shadow: none !important;\n}\n\n.valueContainer > div {\n\tcolor: #666 !important;\n}\n\n.requiredMark {\n\tcolor: #e41d1d;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 18px;\n}\n\n.indicatorsContainer > span {\n\tdisplay: none;\n}\n\n.indicatorsContainer > div {\n\tpadding: 0;\n}\n\n.pInnerLabel {\n\tcolor: #494747 !important;\n\tfont-family: Manrope !important;\n\tfont-size: 14px !important;\n\tfont-style: normal !important;\n\tfont-weight: 600 !important;\n\tline-height: 18px !important; /* 128.571% */\n\ttext-transform: uppercase;\n\tmargin-bottom: 8px;\n}\n\n.pLabel {\n\tmin-height: 56px;\n\theight: 56px;\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {\n}\n\n@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) {\n\t.input,\n\t.countryInput {\n\t\tgap: 11px;\n\t}\n}\n\n@media only screen and (max-width: 820px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 480px) {\n\t.mini {\n\t\twidth: 100% !important;\n\t}\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n}\n\n@media only screen and (max-width: 360px) {\n}\n\n@media only screen and (max-width: 360px) and (min-width: 301px) {\n}\n\n@media only screen and (max-width: 300px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `InputField_label__5A4A+`,
	"ignoreHeight": `InputField_ignoreHeight__Oirzy`,
	"inputFieldCon": `InputField_inputFieldCon__DXBoI`,
	"input": `InputField_input__RQj8i`,
	"countryInput": `InputField_countryInput__gqHDW`,
	"filled": `InputField_filled__pchvw`,
	"placeholderSpan": `InputField_placeholderSpan__ma+hb`,
	"selectControl": `InputField_selectControl__NUc-I`,
	"selectOption": `InputField_selectOption__gqtlH`,
	"password": `InputField_password__g6C1Y`,
	"mini": `InputField_mini__20hfs`,
	"setVisible": `InputField_setVisible__NzyOs`,
	"innerLabel": `InputField_innerLabel__3CIPe`,
	"input_": `InputField_input___E30dc`,
	"select": `InputField_select__tzg6p`,
	"selectControl_": `InputField_selectControl___vCWw6`,
	"valueContainer": `InputField_valueContainer__pre25`,
	"requiredMark": `InputField_requiredMark__q0OlL`,
	"indicatorsContainer": `InputField_indicatorsContainer__3w9VC`,
	"pInnerLabel": `InputField_pInnerLabel__gzK-M`,
	"pLabel": `InputField_pLabel__2anQ3`
};
export default ___CSS_LOADER_EXPORT___;
